<template>
    <div>
                
                <div class="row">

                
                <b-field :label="'User Name'">
                    <b-input custom-class="binput" @keyup.enter.native="login" type="text" v-model.trim="user_name">
                    </b-input>
                </b-field>

            <b-field :label="'Password'">
                <b-input custom-class="binput" @keyup.enter.native="login" type="password" v-model.trim="password">
                </b-input>
            </b-field>

            <div style="height: 10px;">
                    &nbsp;
            </div>
                
            <a @click="login" class="button is-medium is-fullwidth is-primary">Login</a>

            </div>
            
        
    </div>
    
</template>

<script>
    export default {
        data() {
            return {
                user_name: '',
                password: ''
            }
        },
        methods: {
            login() {
                this.$store.dispatch('login', {user_name: this.user_name, password: this.password})
            }
        }
    }
</script>

<style scoped>

    .container {
        width: 30%;
        padding: 20px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        background-color: #fff; 
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: 400px;
    }


/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 1024px) {
    .container {
      width: 80%;
    }
    img {
      width: 70%;
    }
}

@media screen and (max-width: 300px) {
    
}

</style>



// WEBPACK FOOTER //
// src/views/Sessions/Login/Login.vue